<template>
    <div class="bi-com bi-input">
        <label class="bi-lbl"
            :for="id">{{label}}</label>
        <div class="bi-wrapper">
            <input type="tel"
                :id="id"
                class="bi-ib"
                :class="{'bi-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                :maxlength="maxLength"
                v-model="content"
                @input="onChange()" />
            <span class="bi-placeholder"
                :class="{'bi-placeholder-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}"
                v-show="!content">{{placeholder}}</span>
        </div>
        <div class="bi-lbl-error"
            v-if="isShowErrorLbl"
            v-show="!isFirstSave && !errorInfo.isValid">{{errorInfo.msg}}</div>
    </div>
</template>
<script>
import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * Property
 * @property {string} inputId (required) Field id for emit.
 * @property {object} inputLbl (required) Text for component.
 * @property {number} inputMinLength (optional) Minimum length.
 * @property {number} inputMaxLength (optional) Maximum Length.
 * @property {boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {object} errorInfo (required) Validation status.
 * Event
 * @event onChange Filter and validate.
 * Method
 * @method validateInput Validate text.
 */
export default {
    name: "Zipcode",
    props: {
        //v-model
        value: String,
        //props
        inputId: String,
        inputLbl: Object,
        inputMinLength: Number,
        inputMaxLength: Number,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object
    },
    data: function() {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            minLength: 0,
            maxLength: 0
        };
    },
    mounted: function() {
        this.id = this.inputId;
        this.label = this.inputLbl.name || 'Label';
        this.placeholder = this.inputLbl.placeholder || 'Placeholder';
        this.minLength = this.inputMinLength || null;
        this.maxLength = this.inputMaxLength || null;
        this.validateInput();
    },
    methods: {
        validateInput: function () {
             if(!this.inputLbl) return;
             //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required
                && !this.content) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
            //Too short
            if(this.inputLbl.too_short && this.maxLength
                && (this.content.length < this.maxLength)) {

                this.errorInfo.isValid = false;
                this.errorInfo.msg = Util.stringFormat(this.inputLbl.too_short, this.maxLength);
                return;
            }
            //InValid format
            if(this.inputLbl.invalid) {
                if(!Vue.validator.validateZipCode(this.content)) {

                    this.errorInfo.isValid = false;
                    this.errorInfo.msg = this.inputLbl.invalid;
                    return;
                }
            }
        },
        onZipcodeChange: function () {
            this.$emit("onZipcodeChange", {});
        },
        onChange: function() {
            var result = this.content;
            //Remove restrict character.
            result = result.replace(Vue.RegExp.emoji, '');
            result = result.replace(Vue.RegExp.notNumber, '');

            this.validateInput();
            this.content = result;
            this.$emit("input", result);

            this.onZipcodeChange();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";
</style>
